import { createSlice } from '@reduxjs/toolkit'
import { fetchMembers } from '../fetch/search';
const counterSlice = createSlice({
  name: 'members',
  initialState: {
    isLoading: false,
    value: [],
    isError: false,
    page:0,
    totalPages:0,
    totalCount: 0
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMembers.pending, (state, action) => {
      state.isLoading = true;
    })
    builder.addCase(fetchMembers.fulfilled, (state, action) => {
      state.isLoading = false;
      let data = action.payload;

      state.page = data.pageNumber;
      state.totalCount = data.totalCount;
      state.totalPages = data.totalPages;

      if (data.items && data.items.constructor === Array)
        state.value = data.items;
    })
    builder.addCase(fetchMembers.rejected, (state, action) => {
      state.isError = true;
    })
  },
  reducers: {


    // incremented: state => {
    //   // Redux Toolkit allows us to write "mutating" logic in reducers. It
    //   // doesn't actually mutate the state because it uses the Immer library,
    //   // which detects changes to a "draft state" and produces a brand new
    //   // immutable state based off those changes
    //   state.value += 1
    // },
    // decremented: state => {
    //   state.value -= 1
    // },
    // setMembers: (state, action) => {
    //   state.value = action.list;
    // },
  }
})
export const selectMembers = (state) => state.members.value
export const selectPage = (state) => state.members.page
export const selectTotalCount = (state) => state.members.totalCount
export const selectTotalPages = (state) => state.members.totalPages
export const selectLoadingMembers = (state) => state.members.isLoading

export const { incremented, decremented, setMembers } = counterSlice.actions

export default counterSlice.reducer

